import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import BooleanValue from "../../value/BooleanValue";
import UnlockSkillNode from "../common/UnlockSkillNode";
import SkillNodePurchaseListener from "../SkillNodePurchaseListener";

export default class AutomationUnlockSkillNode extends UnlockSkillNode {
    /**
     * @param {string} id 
     * @param {string} title 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     * @param {BooleanValue} unlockValue
     */
    constructor(id, title, description, totals, iconFileName, cost, purchaseListener, unlockValue) {
        super(id, title, description, totals, iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {BooleanValue}
         */
        this.unlockValue = unlockValue;
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.unlockValue.setValue(true);
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        super.onPurchaseFromSave();
        this.unlockValue.setValue(true);
    }

}